var map = {
	"./08eeb56c1f8d92c285449e5918afc89b.jpeg": "3acf",
	"./1111.png": "243a",
	"./20a4de865550766e013241a09115bdc1.jpg": "32f4",
	"./6c95396e8ec959908a1177c34dbe5fb8.jpg": "0b18",
	"./7aa0bbcf2f08679465ee3c8907b72441.jpg": "f194",
	"./Banner.jpg": "5b99",
	"./Banner2.jpg": "1f9a",
	"./Carbon1.jpg": "f4b4",
	"./Carbon2.jpg": "398a",
	"./N016_unfold.png": "8fa0",
	"./SelfAdhesive1.jpg": "0cb7",
	"./SelfAdhesive2.jpg": "5cca",
	"./Signs.jpg": "1f23",
	"./Signs2.jpg": "666f",
	"./SprayPainting2.jpg": "21d2",
	"./aviodPhoney/bg_aviodPhoney_01.jpg": "90af",
	"./aviodPhoney/bg_aviodPhoney_02.jpg": "a300",
	"./aviodPhoney/bg_aviodPhoney_03.jpg": "10ce",
	"./aviodPhoney/bg_aviodPhoney_04.jpg": "0dd8",
	"./aviodPhoney/icon_sec2_01.png": "9915",
	"./aviodPhoney/icon_sec2_02.png": "c9b8",
	"./aviodPhoney/icon_sec3_01.png": "1687",
	"./aviodPhoney/icon_sec3_02.png": "a548",
	"./aviodPhoney/icon_sec3_03.png": "388f",
	"./aviodPhoney/icon_sec3_04.png": "ec68",
	"./aviodPhoney/icon_sec4_01.png": "ee1f",
	"./aviodPhoney/icon_sec4_02.png": "6fc3",
	"./aviodPhoney/icon_sec4_03.png": "f10a",
	"./aviodPhoney/icon_sec6_01.png": "e422",
	"./aviodPhoney/icon_sec6_02.png": "4843",
	"./aviodPhoney/icon_sec6_03.png": "dff9",
	"./aviodPhoney/icon_sec6_04.png": "c83e",
	"./aviodPhoney/icon_sec6_05.png": "54da",
	"./aviodPhoney/img_aviodPhoney_01.jpg": "1ab4",
	"./aviodPhoney/img_aviodPhoney_02.jpg": "5b7e",
	"./aviodPhoney/img_aviodPhoney_03.jpg": "0d8a",
	"./aviodPhoney/img_aviodPhoney_04.jpg": "aee0",
	"./aviodPhoney/img_aviodPhoney_05.jpg": "74e1",
	"./aviodPhoney/img_aviodPhoney_06.jpg": "4bcc",
	"./aviodPhoney/img_aviodPhoney_07.jpg": "27ed",
	"./aviodPhoney/img_sec2_01.png": "140b",
	"./aviodPhoney/img_sec2_02.png": "f919",
	"./aviodPhoney/img_sec5_01.jpg": "bf73",
	"./aviodPhoney/img_sec5_02.jpg": "fce1",
	"./aviodPhoney/img_sec5_03.jpg": "cd17",
	"./aviodPhoney/logo_aviodPhoney.png": "d980",
	"./b79928d7bf28702f0f4c3a5348208f00.jpeg": "98bf",
	"./banner/Banner.jpg": "7ccf",
	"./banner/Banner2.jpg": "2e27",
	"./beijing1.png": "acc5",
	"./beijing2.png": "fb18",
	"./bg.gif": "ac69",
	"./bg_circle.png": "6ac6",
	"./bg_green_popular.png": "b6f0",
	"./bg_orange_popular.png": "dfbc",
	"./bg_red_popular.png": "f1de",
	"./bg_title.png": "8239",
	"./carbon/Carbon1.jpg": "dea7",
	"./carbon/Carbon2.jpg": "7816",
	"./card/minp2.jpg": "f790",
	"./card/minpian1.jpg": "4a14",
	"./card/minpian3.jpg": "d5ac",
	"./colorBox/Integrated_box.png": "5d7b",
	"./colorBox/aircraft_box1.png": "b16a",
	"./colorBox/aircraft_box2.png": "cb10",
	"./colorBox/aircraft_box3.png": "7df3",
	"./colorBox/aircraft_box4.png": "f9d9",
	"./colorBox/automatic_bottom_lock_box.png": "a171",
	"./colorBox/automatic_bottom_lock_box1.png": "94c5",
	"./colorBox/automatic_bottom_lock_box2.png": "9803",
	"./colorBox/automatic_bottom_lock_box3.png": "18c8",
	"./colorBox/automatic_bottom_lock_box4.png": "5d13",
	"./colorBox/automatic_bottom_lock_box_hook1.png": "8ed5",
	"./colorBox/automatic_bottom_lock_box_hook2.png": "0fd7",
	"./colorBox/automatic_bottom_lock_box_safety1.png": "f292",
	"./colorBox/automatic_bottom_lock_box_safety2.png": "d71b",
	"./colorBox/barrel_sleeve1.png": "771d",
	"./colorBox/barrel_sleeve2.png": "13de",
	"./colorBox/barrel_sleeve3.png": "d9f2",
	"./colorBox/barrel_sleeve4.png": "e7e8",
	"./colorBox/closed_handle_box1.png": "9fcc",
	"./colorBox/closed_handle_box2.png": "ad45",
	"./colorBox/closed_handle_box3.png": "d971",
	"./colorBox/closed_handle_box4.png": "74e2",
	"./colorBox/colorBox1.jpg": "a91c",
	"./colorBox/colorBox2.jpg": "a23f",
	"./colorBox/double_plug_box.png": "54aa",
	"./colorBox/double_plug_box1.png": "5426",
	"./colorBox/double_plug_box2.png": "306d",
	"./colorBox/double_plug_box3.png": "f267",
	"./colorBox/double_plug_box4.png": "a06c",
	"./colorBox/double_plug_hook_box1.png": "b55b",
	"./colorBox/double_plug_hook_box2.png": "80a2",
	"./colorBox/double_plug_hook_box3.png": "c123",
	"./colorBox/double_plug_hook_box4.png": "89c7",
	"./colorBox/double_plug_the_same_side_box1.png": "e025",
	"./colorBox/double_plug_the_same_side_box2.png": "39b4",
	"./colorBox/double_plug_the_same_side_box3.png": "c529",
	"./colorBox/double_plug_the_same_side_box4.png": "79be",
	"./colorBox/drawer_box.png": "b590",
	"./colorBox/drawer_box1.png": "be44",
	"./colorBox/drawer_box2.png": "43bb",
	"./colorBox/drawer_box3.png": "bf23",
	"./colorBox/drawer_box4.png": "9528",
	"./colorBox/drawer_box5.png": "002a",
	"./colorBox/drawer_box6.png": "71e4",
	"./colorBox/flat_adhesive_box.png": "67f3",
	"./colorBox/flat_adhesive_box1.png": "7742",
	"./colorBox/flat_adhesive_box2.png": "9f26",
	"./colorBox/heaven_and_earth_box.png": "cabd",
	"./colorBox/heaven_and_earth_box1.png": "7832",
	"./colorBox/heaven_and_earth_box2.png": "2347",
	"./colorBox/heaven_and_earth_box3.png": "5576",
	"./colorBox/heaven_and_earth_box4.png": "1cd0",
	"./colorBox/heaven_and_earth_box5.png": "00f8",
	"./colorBox/lock_bottom_box.png": "87f0",
	"./colorBox/lock_bottom_box1.png": "2c5b",
	"./colorBox/lock_bottom_box2.png": "c871",
	"./colorBox/lock_bottom_box3.png": "85ed",
	"./colorBox/lock_bottom_box4.png": "a90c",
	"./colorBox/lock_bottom_hook_box1.png": "7f11",
	"./colorBox/lock_bottom_hook_box2.png": "2819",
	"./colorBox/lock_bottom_hook_box3.png": "5ff4",
	"./colorBox/other_box_type.png": "f8f2",
	"./colorBox/other_box_type1.png": "6446",
	"./colorBox/safety_lock_bottom_box1.png": "0992",
	"./colorBox/safety_lock_bottom_box2.png": "4022",
	"./colorBox/tear_cover_flat_adhesive_box1.png": "66cd",
	"./colorBox/tear_cover_flat_adhesive_box2.png": "b7e5",
	"./colorBox/tear_cover_flat_adhesive_box3.png": "3d2a",
	"./colorBox/tear_cover_flat_adhesive_box4.png": "714e",
	"./colorBox/zzhd.png": "cd6c",
	"./corrugatedBox/CorrugatedBox1.jpg": "7a88",
	"./corrugatedBox/CorrugatedBox2.jpg": "452b",
	"./corrugatedBox/automatic_bottom_lock_box_safety1.png": "95fc",
	"./corrugatedBox/automatic_bottom_lock_box_safety2.png": "9bff",
	"./corrugatedBox/double_plug_box.png": "0b4b",
	"./corrugatedBox/double_plug_box1.png": "037e",
	"./corrugatedBox/double_plug_box2.png": "e5aa",
	"./corrugatedBox/double_plug_hook_box1.png": "878e",
	"./corrugatedBox/double_plug_hook_box2.png": "69b2",
	"./corrugatedBox/double_plug_the_same_side_box1.png": "7eca",
	"./corrugatedBox/double_plug_the_same_side_box2.png": "48ba",
	"./corrugatedBox/heaven_and_earth_box.png": "58e9",
	"./corrugatedBox/heaven_and_earth_box1.png": "d818",
	"./corrugatedBox/heaven_and_earth_box2.png": "c1e8",
	"./corrugatedBox/lock_bottom_box.png": "8b57",
	"./corrugatedBox/lock_bottom_box1.png": "d892",
	"./corrugatedBox/lock_bottom_box2.png": "4942",
	"./corrugatedBox/lock_bottom_hook_box1.png": "0cc9",
	"./corrugatedBox/lock_bottom_hook_box2.png": "6b26",
	"./corrugatedBox/safety_lock_bottom_box1.png": "e816",
	"./corrugatedBox/safety_lock_bottom_box2.png": "06c7",
	"./cunyanglogo.jpg": "79ff",
	"./danye/DigitalSinglePage.jpg": "675c",
	"./danye/DigitalSinglePage1.jpg": "9eff",
	"./danye/img.zcool(1).jpg": "8d4f",
	"./danye/img.zcool.jpg": "268b",
	"./dc6bda88723ce9dfaa82de5c9e19191f.jpg": "8cbe",
	"./demandHall/icon_demand_cgxq.png": "115b",
	"./demandHall/icon_demand_hjdd.png": "9260",
	"./demandHall/icon_demand_quick.png": "dd4e",
	"./demandHall/icon_demand_slow.png": "26bc",
	"./demandHall/icon_demand_xjxq.png": "c5c5",
	"./demandHall/img_demand_01.png": "dc20",
	"./demandHall/img_demand_02.jpg": "8aa0",
	"./fangdajing.png": "50e1",
	"./fengtao.a034c00c.jpg": "535a",
	"./fengtao.jpg": "dbb3",
	"./fengtao/fengtao(2).jpg": "4faf",
	"./fengtao/fengtao.jpg": "2d2b",
	"./floatbgc.png": "95ad",
	"./goodlist/Carbon1.jpg": "cac1",
	"./goodlist/SprayPainting1.jpg": "8187",
	"./goodlist/SprayPainting2.jpg": "d913",
	"./goodlist/SprayPainting3.jpg": "3813",
	"./goodlist/SprayPainting4.jpg": "a20a",
	"./goodlist/banner1.jpg": "a481",
	"./goodlist/banner2.jpg": "390a",
	"./goodlist/banner3.jpg": "7613",
	"./goodlist/banner4.jpg": "f35b",
	"./goodlist/banner5.jpg": "6b64",
	"./goodlist/banner6.jpg": "db23",
	"./goodlist/banner7.jpg": "e505",
	"./goodlist/colorBox1.jpg": "9ad7",
	"./goodlist/colorBox2.jpg": "9daf",
	"./goodlist/colorBox3.jpg": "dfe50",
	"./goodlist/colorBox4.jpg": "6aff",
	"./goodlist/colorBox5.jpg": "4616",
	"./goodlist/colorBox6.jpg": "b3af",
	"./goodlist/colorBox7.jpg": "aa32",
	"./goodlist/colorBox8.jpg": "7a62",
	"./goodlist/colorBox9.jpg": "b3f8",
	"./goodlist/corrugatedBox1.jpg": "f191",
	"./goodlist/corrugatedBox10.jpg": "ec225",
	"./goodlist/corrugatedBox11.jpg": "a227e",
	"./goodlist/corrugatedBox12.jpg": "7883",
	"./goodlist/corrugatedBox13.jpg": "99a3",
	"./goodlist/corrugatedBox14.jpg": "cac7",
	"./goodlist/corrugatedBox15.jpg": "559e",
	"./goodlist/corrugatedBox16.jpg": "ba60",
	"./goodlist/corrugatedBox17.jpg": "9bf4",
	"./goodlist/corrugatedBox2.jpg": "4f6f",
	"./goodlist/corrugatedBox3.jpg": "7ec1",
	"./goodlist/corrugatedBox4.jpg": "c06d",
	"./goodlist/corrugatedBox5.jpg": "7833",
	"./goodlist/corrugatedBox6.jpg": "bd4b",
	"./goodlist/corrugatedBox7.jpg": "da849",
	"./goodlist/corrugatedBox8.jpg": "60d8",
	"./goodlist/corrugatedBox9.jpg": "f248",
	"./goodlist/danye1.jpg": "5bec",
	"./goodlist/danye10.jpg": "0942",
	"./goodlist/danye11.jpg": "640b",
	"./goodlist/danye2.jpg": "5049",
	"./goodlist/danye3.jpg": "302d",
	"./goodlist/danye4.jpg": "e22f",
	"./goodlist/danye5.jpg": "56bd",
	"./goodlist/danye6.jpg": "94a8",
	"./goodlist/danye7.jpg": "a07f",
	"./goodlist/danye8.jpg": "3918",
	"./goodlist/danye9.jpg": "ba18",
	"./goodlist/envelope1.jpg": "0ad9",
	"./goodlist/envelope10.jpg": "1689",
	"./goodlist/envelope2.jpg": "98b6",
	"./goodlist/envelope3.jpg": "6032",
	"./goodlist/envelope4.jpg": "76e7",
	"./goodlist/envelope5.jpg": "5626",
	"./goodlist/envelope6.jpg": "8d62",
	"./goodlist/envelope7.jpg": "3e67",
	"./goodlist/envelope8.jpg": "29c9",
	"./goodlist/envelope9.jpg": "2ae8",
	"./goodlist/guali1.jpg": "53dd",
	"./goodlist/guali2.jpg": "f967",
	"./goodlist/guali3.jpg": "b4df",
	"./goodlist/huace1.jpg": "647b",
	"./goodlist/huace10.jpg": "f85f",
	"./goodlist/huace11.jpg": "f88d",
	"./goodlist/huace12.jpg": "d5df",
	"./goodlist/huace13.jpg": "f905",
	"./goodlist/huace14.jpg": "772c",
	"./goodlist/huace15.jpg": "aeb8",
	"./goodlist/huace16.jpg": "40bb",
	"./goodlist/huace17.jpg": "08bf",
	"./goodlist/huace18.jpg": "b7b7",
	"./goodlist/huace19.jpg": "81eb",
	"./goodlist/huace2.jpg": "1e0a",
	"./goodlist/huace20.jpg": "31a5",
	"./goodlist/huace3.jpg": "bb35",
	"./goodlist/huace4.jpg": "ad5b",
	"./goodlist/huace5.jpg": "e124",
	"./goodlist/huace6.jpg": "5150",
	"./goodlist/huace7.jpg": "dcf3",
	"./goodlist/huace8.jpg": "9cd4",
	"./goodlist/huace9.jpg": "e990",
	"./goodlist/jingzhuang1.jpg": "6862",
	"./goodlist/jingzhuang10.jpg": "d9e5",
	"./goodlist/jingzhuang11.jpg": "8800",
	"./goodlist/jingzhuang12.jpg": "2554",
	"./goodlist/jingzhuang2.jpg": "63fb",
	"./goodlist/jingzhuang3.jpg": "0535",
	"./goodlist/jingzhuang4.jpg": "be71",
	"./goodlist/jingzhuang5.jpg": "c7f7",
	"./goodlist/jingzhuang6.jpg": "f6fc",
	"./goodlist/jingzhuang7.jpg": "5215",
	"./goodlist/jingzhuang8.jpg": "f8c3",
	"./goodlist/jingzhuang9.jpg": "5641",
	"./goodlist/reticule1.jpg": "dccf",
	"./goodlist/reticule2.jpg": "fef9",
	"./goodlist/reticule3.jpg": "bae2",
	"./goodlist/reticule4.jpg": "54e3",
	"./goodlist/reticule5.jpg": "9274",
	"./goodlist/selfAdhesive1.jpg": "2034",
	"./goodlist/selfAdhesive10.jpg": "b1ef",
	"./goodlist/selfAdhesive11.jpg": "fcbd",
	"./goodlist/selfAdhesive2.jpg": "6f25",
	"./goodlist/selfAdhesive3.jpg": "50fe",
	"./goodlist/selfAdhesive4.jpg": "bdfb",
	"./goodlist/selfAdhesive5.jpg": "0466",
	"./goodlist/selfAdhesive6.jpg": "56a1",
	"./goodlist/selfAdhesive7.jpg": "cab3",
	"./goodlist/selfAdhesive8.jpg": "31bd",
	"./goodlist/selfAdhesive9.jpg": "60e8",
	"./goodlist/showbill1.png": "ad0e",
	"./goodlist/showbill3.jpg": "f6ee",
	"./goodlist/showbill4.jpg": "8e31",
	"./goodlist/showbill5.jpg": "f6d1",
	"./goodlist/showbill6.jpg": "bd5f4",
	"./goodlist/showbill7.jpg": "54d6",
	"./goodlist/showbill8.jpg": "9af8",
	"./goodlist/signs1.jpg": "743e",
	"./goodlist/signs10.jpg": "a0c7",
	"./goodlist/signs11.jpg": "7aea",
	"./goodlist/signs12.jpg": "f944",
	"./goodlist/signs13.jpg": "89d5",
	"./goodlist/signs14.jpg": "ab1b",
	"./goodlist/signs15.jpg": "8389",
	"./goodlist/signs16.jpg": "edba",
	"./goodlist/signs1_1.jpg": "4baf",
	"./goodlist/signs1_2.jpg": "be03",
	"./goodlist/signs1_3.jpg": "76a0",
	"./goodlist/signs1_4.jpg": "e520",
	"./goodlist/signs2.jpg": "c5eb",
	"./goodlist/signs3.jpg": "162c",
	"./goodlist/signs4.jpg": "6f89",
	"./goodlist/signs5.jpg": "39af",
	"./goodlist/signs6.jpg": "36a5",
	"./goodlist/signs7.jpg": "01bd",
	"./goodlist/signs8.jpg": "a9e1",
	"./goodlist/signs9.jpg": "dc3c",
	"./goodlist/taili1.jpg": "7921",
	"./goodlist/taili10.jpg": "91c6",
	"./goodlist/taili11.jpg": "fe12",
	"./goodlist/taili12.jpg": "3951",
	"./goodlist/taili13.jpg": "649d",
	"./goodlist/taili2.jpg": "f1fd",
	"./goodlist/taili3.jpg": "d596",
	"./goodlist/taili4.jpg": "b636",
	"./goodlist/taili5.jpg": "f2b5",
	"./goodlist/taili6.jpg": "8089",
	"./goodlist/taili7.jpg": "a7cb",
	"./goodlist/taili8.jpg": "17f1",
	"./goodlist/taili9.jpg": "1fb0",
	"./guali.ec96a8b6.jpg": "1ecb",
	"./guali.jpg": "a653",
	"./guali/DigitalCalendar1.jpg": "059f",
	"./guali/DigitalCalendar2.jpg": "4db7",
	"./guali/guali(2).jpg": "d466",
	"./guali/guali(3).jpg": "b14b",
	"./guali/guali.jpg": "81b9",
	"./help.png": "4ed1",
	"./huace/DigitalAlbum1.jpg": "29fa",
	"./huace/DigitalAlbum2.jpg": "3cea",
	"./huace/huace.jpg": "09a7",
	"./huace/img_hc_big.png": "b596",
	"./huace/img_size1_hc.png": "6dfd",
	"./huace/img_size2_hc.png": "13ec",
	"./huace/img_size3_hc.png": "3017",
	"./huace/img_size4_hc.png": "9212",
	"./huace/img_size5_hc.png": "9400",
	"./huace/img_size6_hc.png": "b000",
	"./huace/img_size7_hc.png": "a397",
	"./icon-angle-up.png": "7931",
	"./icon_1F.png": "1627",
	"./icon_2F.png": "1f07",
	"./icon_3F.png": "1a13",
	"./icon_4F.png": "43bd",
	"./icon_access.png": "064a",
	"./icon_allProduct.png": "c843",
	"./icon_arrow_process.png": "e1f3",
	"./icon_arrow_selected.png": "c21c",
	"./icon_cart.png": "d934",
	"./icon_checkbox_checked.png": "6f8d",
	"./icon_checkbox_unchecked.png": "336d",
	"./icon_demand_quality.png": "a424",
	"./icon_demand_service.png": "f454",
	"./icon_discusion.png": "2b2f",
	"./icon_download.png": "b212",
	"./icon_drop-down.png": "4bcb",
	"./icon_head_default.png": "c9f1",
	"./icon_hot.png": "ff7b",
	"./icon_index.png": "fd85",
	"./icon_link_hot.png": "2d25",
	"./icon_little_location.png": "1971",
	"./icon_location.png": "24f7",
	"./icon_logo_blue.png": "e40a",
	"./icon_logo_white.png": "56f0",
	"./icon_maodian.png": "351c",
	"./icon_maodian_QQ.png": "caf4",
	"./icon_master.png": "f61b",
	"./icon_minus_num.png": "3fbd",
	"./icon_phone.png": "a2cb",
	"./icon_plus_num.png": "b18c",
	"./icon_product01.png": "25c8",
	"./icon_product02.png": "7b13",
	"./icon_product03.png": "da54",
	"./icon_product04.png": "e656",
	"./icon_product05.png": "0b96",
	"./icon_product06.png": "be74",
	"./icon_product07.png": "8bbf",
	"./icon_product08.png": "3861",
	"./icon_product09.png": "2070",
	"./icon_product10.png": "c788",
	"./icon_product11.png": "ae6e",
	"./icon_product12.png": "eeed",
	"./icon_product13.png": "a30f",
	"./icon_qrCode.png": "add2",
	"./icon_search.png": "36d4",
	"./icon_sharing.png": "7bc4",
	"./icon_shoppingCar.png": "d695",
	"./icon_sidebar_client.png": "e6838",
	"./icon_sidebar_contactTel.png": "bb52",
	"./icon_sidebar_hotline.png": "aead",
	"./icon_sidebar_quote.png": "980b",
	"./icon_sidebar_top.png": "f605",
	"./icon_sidebar_vcode.png": "5e7f",
	"./icon_tel.png": "d4a1",
	"./icon_tel_white.png": "9d25",
	"./icon_triangle_checked.png": "a7da",
	"./icon_triangle_checked_blue.png": "1d35",
	"./icon_triangle_white.png": "12e1",
	"./icon_vip_default.png": "17ee",
	"./icon_waitDevelop.png": "8ad0",
	"./img.zcool.8b4912aa.jpg": "f931",
	"./img.zcool.jpg": "82e4",
	"./img_ch.jpg": "3594",
	"./img_cx.jpg": "797d",
	"./img_hc.png": "8bef",
	"./img_hotProduct_test.png": "95e0",
	"./img_investment.jpg": "283b",
	"./img_jf.jpg": "fb9b",
	"./img_jf.png": "bcc4",
	"./img_mp.png": "1c68",
	"./img_notice_test.jpg": "f813",
	"./img_orderInfoBox.png": "4b0b",
	"./img_paperMaterial1_test.png": "59fa",
	"./img_paperMaterial2_test.png": "7ae0",
	"./img_paperMaterial3_test.png": "7504",
	"./img_paperMaterial4_test.png": "8459",
	"./img_qrCode_app.jpg": "0854",
	"./img_qrCode_weChat.jpg": "3ae3",
	"./img_show1.jpg": "07ae",
	"./img_size1_test.png": "8129",
	"./img_size2_test.png": "ba07",
	"./img_size3_test.png": "8369",
	"./img_size4_test.png": "0e74",
	"./img_size5_test.png": "b2e4",
	"./img_size6_test.png": "ccd1",
	"./img_size7_test.png": "67dc",
	"./img_sld.png": "2d15",
	"./img_sld2.png": "1597",
	"./img_sld3.png": "0430",
	"./img_sld_big.png": "3c1f",
	"./img_ysjg.jpg": "fc3c",
	"./img_zzjg.jpg": "ff49",
	"./index_banner01.jpg": "5c9b",
	"./index_banner02.jpg": "1402",
	"./index_banner03.jpg": "879d",
	"./index_banner04.jpg": "63a3",
	"./index_banner1.jpg": "ef43",
	"./index_footer_deliver.png": "71ce",
	"./index_footer_pay.png": "7258",
	"./index_footer_quality.png": "fc55",
	"./index_footer_service.png": "6671",
	"./jianjie1.jpg": "0e0d",
	"./jianjie2.jpg": "4799",
	"./jingzhuangshu1.jpg": "dc05",
	"./jingzhuangshu2.jpg": "5d52",
	"./lab.png": "3b57",
	"./login.jpg": "4580",
	"./logo.png": "325a",
	"./minpian.jpg": "1246",
	"./order.jpg": "651b",
	"./personalCenter/bg_topDiv.jpg": "64d8",
	"./personalCenter/bg_topDiv.png": "40a6",
	"./personalCenter/icon_mineLeft01.png": "334a",
	"./personalCenter/icon_mineLeft02.png": "e6e4",
	"./personalCenter/icon_mineLeft03.png": "a368",
	"./personalCenter/icon_msgCenter.png": "c0cd",
	"./personalCenter/icon_orderStatus.png": "6516",
	"./personalCenter/icon_vip.png": "5ae1",
	"./personalCenter/icon_waitEstimate.png": "2018",
	"./personalCenter/icon_waitPay.png": "9dd0",
	"./personalCenter/icon_waitReceive.png": "872e",
	"./personalCenter/icon_waitSend.png": "d710",
	"./personalCenter/icon_warning.png": "8db1",
	"./personalCenter/img_head.png": "22a2",
	"./personalCenter/mineyy.png": "331c",
	"./picture_href.jpg": "c789",
	"./printAssociation/icon_activity.png": "4047",
	"./printAssociation/icon_arrow.png": "20ea",
	"./printAssociation/icon_introduce.png": "b6dd",
	"./printAssociation/icon_navigation.png": "991c",
	"./printAssociation/icon_news.png": "70c3",
	"./printAssociation/icon_next.png": "7143",
	"./printAssociation/icon_prev.png": "66e1",
	"./printAssociation/icon_show.png": "17a1",
	"./printAssociation/icon_statute.png": "db37",
	"./printAssociation/news-pic.png": "dde6",
	"./printAssociation/picture_activity.jpg": "1234",
	"./printAssociation/picture_logo1.jpg": "3f1e",
	"./printAssociation/picture_news.jpg": "e75b",
	"./printAssociation/picture_statute.jpg": "f4d6",
	"./printAssociation/picture_swiper.png": "b896",
	"./printAssociationIndex_bg.jpg": "951f",
	"./printIndustrial/icon_logo.png": "c3ac",
	"./printIndustrial/icon_mass.png": "52a5",
	"./printIndustrial/icon_news.jpg": "6cb7",
	"./printIndustrial/icon_office.png": "1d15",
	"./printIndustrial/icon_platfrom.png": "d1fd",
	"./printIndustrial/icon_progressive.png": "8cba",
	"./printIndustrial/icon_protect.png": "084b",
	"./printIndustrial/icon_provide.png": "8b58",
	"./printIndustrial/icon_quality.png": "fbdd",
	"./printIndustrial/nanjing_park.png": "cfee",
	"./printIndustrial/picture_business.png": "017b",
	"./printIndustrial/picture_changsha.jpg": "837d",
	"./printIndustrial/picture_company.png": "f39c",
	"./printIndustrial/picture_dxh.png": "b8f7",
	"./printIndustrial/picture_introduction.png": "0658",
	"./printIndustrial/picture_nanjing.jpg": "fcb9",
	"./printIndustrial/picture_navigation.png": "019f",
	"./printIndustrial/picture_news.png": "87a0",
	"./printIndustrial/picture_ningbo.jpg": "c69b",
	"./printIndustrial/picture_product.png": "a3b2",
	"./printIndustrial/picture_product1.png": "2db0",
	"./printIndustrial/picture_product2.png": "6437",
	"./printIndustrial/picture_wuhan.jpg": "d6e1",
	"./printIndustrial/printIndustrialIndex_bg.jpg": "f5e1",
	"./qrCode_gzh.jpg": "a341",
	"./quote/icon_add.png": "37d8",
	"./quote/icon_del.png": "d763",
	"./quote/icon_hide.png": "926c",
	"./quote/icon_show.png": "2fbe",
	"./quote/img_ch1.jpg": "0cb9",
	"./quote/img_ch1_open.jpg": "7e5d",
	"./quote/img_ch2.jpg": "1956",
	"./quote/img_ch2_open.jpg": "dbca",
	"./quote/img_ch_big.png": "d55d",
	"./quote/img_ch_small.png": "1e41",
	"./quote/img_cx1.jpg": "102f",
	"./quote/img_cx1_open.jpg": "c46b",
	"./quote/img_cx2.jpg": "4e74",
	"./quote/img_cx2_open.jpg": "b9c5",
	"./quote/img_cx3.jpg": "fc0c",
	"./quote/img_cx3_open.jpg": "b13b",
	"./quote/img_cx4.jpg": "ba1b",
	"./quote/img_cx4_open.jpg": "72c9",
	"./quote/img_cx5.jpg": "ce8b",
	"./quote/img_cx5_open.jpg": "3ef1",
	"./quote/img_cx6.jpg": "a68a",
	"./quote/img_cx6_open.jpg": "a7eb",
	"./quote/img_cx7_open.jpg": "8d14",
	"./quote/img_cx8_open.jpg": "15a6",
	"./quote/img_cx9_open.jpg": "6996",
	"./quote/img_cx_big.png": "dbe7",
	"./quote/img_hc_big.png": "4077",
	"./quote/img_size1_hc.png": "16a8",
	"./quote/img_size1_jf.png": "bb53",
	"./quote/img_size2_hc.png": "2d3d3",
	"./quote/img_size2_jf.png": "0a6a",
	"./quote/img_size3_hc.png": "3350",
	"./quote/img_size3_jf.png": "7743",
	"./quote/img_size4_hc.png": "8ad08",
	"./quote/img_size4_jf.png": "b5aa",
	"./quote/img_size5_hc.png": "31be",
	"./quote/img_size6_hc.png": "3d98",
	"./quote/img_size7_hc.png": "4dc5",
	"./selfAdhesive/DigitalAdhesive1.jpg": "edd8",
	"./selfAdhesive/DigitalAdhesive2.jpg": "f2b4",
	"./selfAdhesive/SelfAdhesive1.jpg": "acee",
	"./selfAdhesive/SelfAdhesive2.jpg": "c0ad",
	"./signs/Signs.jpg": "7932",
	"./signs/Signs2.jpg": "f9d2",
	"./slogan.png": "86ad",
	"./smallBatchCustomization/reticule1.jpg": "93b9",
	"./smallBatchCustomization/reticule2.jpg": "0994",
	"./smallBatchCustomization/showbill1.jpg": "08ba",
	"./smallBatchCustomization/showbill2.jpg": "d52d",
	"./sprayPaint/SprayPainting.jpg": "fbea",
	"./sprayPaint/SprayPainting2.jpg": "aa58",
	"./sprites-payment-logo.png": "a76b",
	"./supplier/icon_supplier_sign01.png": "e746",
	"./supplier/icon_supplier_sign02.png": "4ddc",
	"./supplier/img_supplierLogo.png": "8510",
	"./supplierJoin/bg_service.png": "801e",
	"./supplierJoin/icon_loc_left.png": "ef25",
	"./supplierJoin/icon_sec1_01.png": "cacd",
	"./supplierJoin/icon_sec1_02.png": "0613",
	"./supplierJoin/icon_sec1_03.png": "3751",
	"./supplierJoin/icon_sec2_01.png": "d030",
	"./supplierJoin/icon_sec2_02.png": "1327",
	"./supplierJoin/icon_sec2_03.png": "32fe",
	"./supplierJoin/icon_sec2_04.png": "2869",
	"./supplierJoin/icon_sec2_05.png": "56b1",
	"./supplierJoin/icon_sec2_06.png": "0355",
	"./supplierJoin/icon_sec2_07.png": "2284",
	"./supplierJoin/icon_sec2_08.png": "0f9d",
	"./supplierJoin/icon_sec3_01.png": "02db",
	"./supplierJoin/icon_sec3_02.png": "ce01",
	"./supplierJoin/icon_sec3_03.png": "9376",
	"./supplierJoin/icon_sec3_04.png": "4529",
	"./supplierJoin/icon_sec5_01.png": "753f",
	"./supplierJoin/icon_sec5_02.png": "bdd5",
	"./supplierJoin/icon_sec5_03.png": "a0a6",
	"./supplierJoin/icon_sec5_04.png": "fd41",
	"./supplierJoin/icon_sec5_05.png": "282e",
	"./supplierJoin/icon_sec5_06.png": "2ed5",
	"./supplierJoin/icon_sec6_01.png": "0eec",
	"./supplierJoin/icon_sec6_02.png": "f955",
	"./supplierJoin/icon_sec6_03.png": "10b7",
	"./supplierJoin/icon_sec6_04.png": "7ac8",
	"./supplierJoin/icon_sec6_05.png": "dc81",
	"./supplierJoin/icon_sec6_06.png": "e1f0",
	"./supplierJoin/icon_secChoice_01.png": "5c59",
	"./supplierJoin/icon_secChoice_02.png": "2a92",
	"./supplierJoin/icon_secChoice_03.png": "7add",
	"./supplierJoin/img_join_01.jpg": "0e1e",
	"./supplierJoin/img_join_02.jpg": "ae40",
	"./supplierJoin/img_join_03.jpg": "3833",
	"./supplierJoin/img_join_04.jpg": "dcb7",
	"./supplierJoin/img_join_05.jpg": "8eae",
	"./supplierJoin/img_join_06.jpg": "ea9a",
	"./supplierJoin/img_join_07.jpg": "22cf",
	"./supplierJoin/img_map.png": "0d7b",
	"./taili.1dac0ea1.jpg": "58b0d",
	"./taili.jpg": "97d8",
	"./taili/size.jpg": "21a0",
	"./taili/taili(2).jpg": "903f",
	"./taili/taili(3).jpg": "3c0a",
	"./taili/taili.jpg": "b803",
	"./taili_ziidngyi.png": "6f02",
	"./tong.png": "65a9",
	"./typeDownload/img_size_01.png": "9fce",
	"./typeDownload/img_size_02.png": "d0d1",
	"./typeDownload/img_size_03.png": "a7e1",
	"./typeDownload/img_size_04.png": "d0d4",
	"./typeDownload/img_size_05.png": "afd1",
	"./typeDownload/img_size_06.png": "fb46",
	"./typeDownload/img_size_07.png": "1739",
	"./x/zhanjia.jpg": "5fd8",
	"./x/zhanjia1.jpeg": "c38a",
	"./x/zhanjia3.jpeg": "74f4",
	"./xiezhen.jpg": "1b88",
	"./xiezhen/xiezhen1.jpg": "8ba0",
	"./xiezhen/xiezhen2.jpg": "4ce0",
	"./xiezhen/xiezhen3.png": "4f9d",
	"./xxing.jpg": "8cb9",
	"./yilabao.jpg": "9b1e",
	"./yilapao/package.png": "c646",
	"./yilapao/paper.png": "4281",
	"./yilapao/yilapao1.jpg": "b5e3",
	"./yilapao/yilapao2.jpg": "471f",
	"./yilapao/杯子.png": "0bef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc83";